export enum AsqAirportType {
  Airport = 0,
  Operator = 1,
}
